<template>
  <v-text-field
    color="primary"
    density="compact"
    variant="outlined"
    :type="showing ? 'text' : 'password'"
  >
    <template #append-inner>
      <v-icon
        v-if="!showing"
        :icon="mdiEye"
        tabindex="-1"
        :aria-label="$t('showPassword')"
        @click="toggleShowing"
      />
      <v-icon
        v-if="showing"
        :icon="mdiEyeOff"
        tabindex="-1"
        :aria-label="$t('hidePassword')"
        @click="toggleShowing"
      />
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { ref } from 'vue'

const showing = ref(false)

const toggleShowing = () => (showing.value = !showing.value)
</script>
